<template>
    <div>
        <UnitDropdown
            @select="onUnitSelected"
            :selectedUnitId="$route.params.unitId"
            :key="$route.params.unitId"
        />

        <a-row :gutter="10">
            <a-col :span="6" v-if="false">
                <!-- <Navigation :orgId="$route.params.orgId" /> -->
                <UnitTree
                    :orgId="$route.params.orgId"
                    @unitSelected="onUnitSelected"
                />
            </a-col>

            <a-col :span="24" v-if="unitId">
                <UnitCard :unitId="unitId" :key="unitId" />
            </a-col>
        </a-row>
    </div>
</template>

<script>
import UnitCard from '@/components/cards/unitCard'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import UnitTree from '@/components/UnitTree.vue'
import UnitDropdown from '@/components/UnitDropdown'

export default {
    components: {
        UnitTree,
        UnitCard,
        UnitDropdown,
    },

    created() {
        // console.log('OrgIndexCreated', this)
        this.getUnits()
    },

    watch: {
        '$route.query.unitId'() {
            // // console.log('val', oldVal, newVal)
            // this.selectedUnitId = newVal
            this.$nextTick()
        },
    },

    methods: {
        onUnitSelected(key) {
            if (typeof key == 'object') {
                key = key.id
            }
            // console.log('onUnitSelected', key)
            this.$router.push(
                '/organization/' +
                    this.$route.params.orgId +
                    '/directory/' +
                    key
            )
        },

        ...mapActions({
            getUnits: 'companies/getUnits',
        }),

        ...mapMutations({}),
    },

    computed: {
        unitId() {
            if (this.units.length == 0) {
                return ''
            }

            if (this.$route.params.unitId) {
                return this.$route.params.unitId
            }

            return this.rootUnit.id
        },

        ...mapGetters({
            rootUnit: 'companies/rootUnit',
            unitTree: 'companies/unitTree',
            units: 'companies/units',
            unitRoot: 'companies/rootUnit',
        }),
    },
}
</script>
